import { FaCheckCircle, FaRegCopy } from "react-icons/fa"
import "./RefundedPayment.scss"
import React, { useState } from "react"
import { FaCircleMinus } from "react-icons/fa6";
import { RiFlag2Fill, RiRefund2Line } from "react-icons/ri";
import { IoIosTime } from "react-icons/io";
export default function RefundedPayment() {
            const [activeRow, setActiveRow] = useState(null);
            const [open, setOpen] = useState(null);
              const toggleDetails = (index) => {
          setActiveRow(activeRow === index ? null : index);
        };
         const [orders] = useState([
              {
                id: '#301555',
                client: 'Osama alabyaare',
                product: 'Social media',
                date: '12/12/23',
                time: '12:00 PM',
                amount: 'EGP 241.00',
                       status: 'Declined',
                                 icone:<FaCircleMinus/>
              },
              {
                id: '#301556',
                client: 'Osama alabyaare',
                product: 'E-book',
                date: '12/12/23',
                time: '12:00 PM',
                amount: 'EGP 241.00',
       status: 'Refunded',
                   icone:<RiRefund2Line/>
              },
              {
                id: '#301555',
                client: 'Osama alabyaare',
                product: 'Social media',
                date: '12/12/23',
                time: '12:00 PM',
                amount: 'EGP 241.00',
                      status: 'Declined',
                                icone:<FaCircleMinus/>
              },
                  {
                id: '#301555',
                client: 'Osama alabyaare',
                product: 'Social media',
                date: '12/12/23',
                time: '12:00 PM',
                amount: 'EGP 241.00',
                status: 'Refunded',
                   icone:<RiRefund2Line/>
              },
                  {
                id: '#301555',
                client: 'Osama alabyaare',
                product: 'Social media',
                date: '12/12/23',
                time: '12:00 PM',
                amount: 'EGP 241.00',
                    status: 'Refunded',
                   icone:<RiRefund2Line/>
              },
                  {
                id: '#301555',
                client: 'Osama alabyaare',
                product: 'Social media',
                date: '12/12/23',
                time: '12:00 PM',
                amount: 'EGP 241.00',
                     status: 'Declined',
                               icone:<FaCircleMinus/>
              },
                  {
                id: '#301555',
                client: 'Osama alabyaare',
                product: 'Social media',
                date: '12/12/23',
                time: '12:00 PM',
                amount: 'EGP 241.00',
                   status: 'Refunded',
                   icone:<RiRefund2Line/>
              },
              
            ]);
  return (
    <div className="p-3">
          <div className="headerr">
  <div className="stock-filters">
    <button className="stock-filter actives">24 Hour</button>
    <button className="stock-filter">7 Days</button>
    <button className="stock-filter">30 Days</button>
    <button className="stock-filter">12 Months</button>
  </div>

  <div className="search-wrapperr">
    <input
      type="text"
      placeholder="Search by order id"
      className="stock-search"
    />
    <i className="fa-solid fa-magnifying-glass search-icon"></i>
  </div>

  <div className="stock-header">
    <input type="date" placeholder="select dates" />
    <div className="stock-actions">
      <button className="stock-btn blue">Filters</button>
      <button className="stock-btn">Export</button>
    </div>
  </div>
</div>
                <div className="orders-table-wrapper">
                            <table className="orders-table">
            <thead>
                  <tr>
                    <th><input type="checkbox" /></th>
                    <th>Invoice No</th>
                    <th>Client Name</th>
                    <th>Product</th>
                    <th>Date</th>
                    <th>Order time</th>
                    <th>Amount</th>
                       <th className="product-header col" onClick={() => setOpen(open === "Status" ? null : "Status")}>
                        Status
                        <svg className="dropdown-arrow" width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1 1L5 5L9 1" stroke="#666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        {open === "Status" && (
                          <div className="list-body">
                            <ul className="list">
                              <li>All Status</li>
                              <li>New</li>
                              <li>On Process</li>
                              <li>Late Order</li>
                            </ul>
                          </div>
                        )}
                      </th>
                    <th>Order Details</th>
                  </tr>
                </thead>
                              <tbody>
                                {orders.map((order, index) => (
                                  <React.Fragment key={index}>
                                    <tr>
                                      <td><input type="checkbox" /></td>
                                  
                                      <td className="order-id" style={{
                                      color:"#62aec4",
                                      fontWeight:"bold",
                                      marginRight:"10px"
                          
                                  }}>{order.id} <FaRegCopy style={{
                                      color:"#8b8d97",
                                      fontSize:"14px"
                                  }}/></td>
                                      <td>{order.client}</td>
                                      <td>{order.product}</td>
                                      <td>{order.date}</td>
                                      <td>{order.time}</td>
                                      <td>{order.amount}</td>
                                      <td>
                                             <div className={`bg-status ${order.status.toLowerCase()}`}>
                      <span className="icon-circle">
                        {order.icone}
                      
                      </span>
                      {order.status}
                    </div>
                    
                                      </td>
                                      <td>
                                        <span
                                          className="order-details"
                                          onClick={() => toggleDetails(index)}
                                        >
                                          ...
                                        </span>
                                      </td>
                                    </tr>
                    
                                 {activeRow === index && (
                     <>
                    
                        <tr className="details-row headers-row">
                          <td colSpan="9">
                            <div className="order-details-box header" style={{
                                backgroundColor:"#ebf6ff"
                            }}>
                              <div className="section "
                               style={{
                                color:"#999999"
                              }}>Client information</div>
                           
                            </div>
                          </td>
                        </tr>
                        <tr className="details-row values-row"  style={{
                                color:"#999999"
                              }}>
                            
                          <td colSpan="9">
                            <div className="order-details-box values">
                              <h3 className="section">FULL NAME</h3>
                              <h3 className="section">PHONE</h3>
                              <h3 className="section">EMAIL</h3>
                              <h3 className="section">COUNTRY</h3>
                              <h3 className="section">DATE</h3>
                              <h3 className="section">TIME</h3>
                           
                            </div>
                          </td>
                        </tr>
                        
                        <tr className="details-row values-row">
                            
                          <td colSpan="9">
                            <div className="order-details-box values">
                              <h3 className="section">Osama Ali alabyaare</h3>
                              <h3 className="section">+20 1012345678</h3>
                              <h3 className="section">osama@email.com</h3>
                              <h3 className="section">Egypt</h3>
                              <h3 className="section">12/12/23</h3>
                              <h3 className="section">12:00 PM</h3>
                        
                            </div>
                          </td>
                        </tr>
                      <>
                    
                    
                    {/* ////////////////////// */}
                         <tr className="details-row headers-row">
                          <td colSpan="9">
                            <div className="order-details-box header" style={{
                                backgroundColor:"#ebf6ff"
                            }}>
                              <div className="section "
                               style={{
                                color:"#999999"
                              }}>Order information</div>
                           
                            </div>
                          </td>
                        </tr>
                     
                          <tr className="details-row values-row"  style={{
                                color:"#999999"
                              }}>
                            
                          <td colSpan="9">
                            <div className="order-details-box values">
                              <h3 className="section">ORDER TYPE</h3>
                              <h3 className="section">CATEGORY</h3>
                              <h3 className="section">SKU</h3>
                              <h3 className="section">DURATION</h3>
                              <h3 className="section">START</h3>
                              <h3 className="section">ENDS</h3>
                            <h3 className="section">DAYS</h3>
                            </div>
                          </td>
                        </tr>
                        
                        <tr className="details-row values-row">
                          <td colSpan="9">
                            <div className="order-details-box values">
                              <h3 className="section">Service</h3>
                              <h3 className="section">Social media</h3>
                              <h3 className="section">#6580</h3>
                              <h3 className="section">1 month</h3>
                              <h3 className="section">24 may 2025</h3>
                              <h3 className="section">24 may 2025</h3>
                              <h3 className="section">30</h3>
                     
                            </div>
                          </td>
                        </tr>
                    {/* //////////////////////////////////// */}
                    
                      <>
                     <tr className="details-row headers-row">
                          <td colSpan="9">
                            <div className="order-details-box header" style={{
                                backgroundColor:"#ebf6ff"
                            }}>
                              <div className="section "
                               style={{
                                color:"#999999"
                              }}>Payment information</div>
                           
                            </div>
                          </td>
                        </tr>
                        <tr className="details-row values-row"  style={{
                                color:"#999999"
                              }}>
                            
                          <td colSpan="9">
                            <div className="order-details-box values">
                              <h3 className="section">PRICE</h3>
                              <h3 className="section">TOTAL AMOUNT</h3>
                              <h3 className="section">PAYMRNT METHOD</h3>
                              <h3 className="section">BANK NAME</h3>
                              <h3 className="section">ACCOUNT NO</h3>
                              <h3 className="section">DUE DATE</h3>
                              <h3 className="section">PAYMENT STATUS</h3>
                            </div>
                          </td>
                        </tr>
                        
                        <tr className="details-row values-row">
                          <td colSpan="9">
                            <div className="order-details-box values">
                              <h3 className="section">EGP200</h3>
                              <h3 className="section">EGP200</h3>
                              <h3 className="section">credit card</h3>
                              <h3 className="section">+insta</h3>
                              <h3 className="section">********65</h3>
                              <h3 className="section">24 may 2025</h3>
                                    <h3 className="section">Successful</h3>
                
                    
                            </div>
                          </td>
                        </tr>
                    
                        
                      </>
                        
                      </>
                        
                      </>
                      
                    )}
                    
                                  </React.Fragment>
                                ))}
                              </tbody>
        
                            </table>
                                                <div className="table-footer">
                <div className="showing-info">
                  Showing 17 of 100
                </div>
                <div className="pagination">
                  <button className="active">1</button>
                  <button>2</button>
                  <button>3</button>
                  <button>4</button>
                  <button>5</button>
                  <button>Next</button>
                </div>
              </div>
       </div>
    </div>
  )
}
